import React from "react";
import {
  Button,
  Grid,
  InputAdornment,
  Box,
  FormControl,
  OutlinedInput,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import "./passwordChange.scss";
import * as acts from "../../../redux/auth/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
import aventiorLogo from "../../../assets/CPV-Auto-logoN.png";
import CustomizedSnackbars from "../../Snackbars/CustomizedSnackbars";
import { notification } from "../../../constants/notificationMessages";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { authRoutes } from "../../../routes/routeConstants";
import { Cancel, CheckCircle } from "@mui/icons-material";
import Label from "../../Label/Label";

class ChangePassword extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      email: "",
      newPassword: "",
      confirmPassword: "",
      emailErrorMessage: "",
      passwordErrorMessage: "",
      inValidUserErrorMessage: "",
      isLoading: false,
      isOpenForgotPasswordDialogBox: false,
      isSuccessMsg: "",
      showPassword: false,
      showConfPassword: false,
      sucessNotification: true,
      token: "",
      isLinkExpired: false,
      passwordRules: {
        length: false,
        lowercase: false,
        uppercase: false,
        number: false,
        specialChar: false,
        noSpace: false,
      },
    };
  }

  componentDidMount() {
    const extractTokenFromUrl = (url) => {
      try {
        const urlObj = new URL(url);
        const pathSegments = urlObj.pathname.split("/");
        if (
          pathSegments[pathSegments.length - 1] !== authRoutes?.forgotPassword
        ) {
          return pathSegments[pathSegments.length - 1];
        }
        return null;
      } catch (error) {
        console.error("Invalid URL");
        return null;
      }
    };

    const tokenFromUrl = extractTokenFromUrl(window.location.href);
    this.setState({ token: tokenFromUrl });
    this.props.acts.clearForgoPasswordStatus();
    this.props.acts.checkLinkStatus(tokenFromUrl);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps?.changePasswordLinkStatus?.expired) {
      this.setState({
        isLinkExpired: true,
      });
    }

    if (
      nextProps.forgotPasswordStatus &&
      nextProps.forgotPasswordStatus !== undefined
    ) {
      if (
        nextProps.forgotPasswordStatus.message !== "" ||
        nextProps.forgotPasswordStatus.status === false
      ) {
        this.setState({
          isErrorMsg: nextProps.forgotPasswordStatus.message,
        });
      }
      if (nextProps.forgotPasswordStatus?.next === true) {
        this.setState({
          isSuccessMsg: this?.props?.forgotPasswordStatus.message,
          isLoading: true,
        });
        setTimeout(() => {
          this.setState({
            isLoading: false,
          });
          this.props.navigate("/", { replace: true });
        }, 2000);
      }

      if (
        nextProps.forgotPasswordStatus.message !== "" ||
        (nextProps.forgotPasswordStatus.loader === false &&
          nextProps.forgotPasswordStatus?.next === false)
      ) {
        this.setState({
          tagNameError: true,
          isMessage: nextProps.forgotPasswordStatus.message,
        });
      }
    }
  }

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  };

  handleNewPasswordChange = (e) => {
    const password = e.target.value;
    const rules = {
      length: password.length >= 8 && password.length <= 20,
      lowercase: /[a-z]/.test(password),
      uppercase: /[A-Z]/.test(password),
      number: /[0-9]/.test(password),
      specialChar: /[@#$%^&+=]/.test(password),
      noSpace: !/\s/.test(password),
    };

    this.setState({
      newPassword: password,
      passwordRules: rules,
      inValidUserErrorMessage: "",
    });

    // this.setState({
    //   newPassword: e.target.value,
    // inValidUserErrorMessage: "",
    // });
  };

  handleConfirmPasswordChange = (e) => {
    this.setState({
      confirmPassword: e.target.value,
      inValidUserErrorMessage: "",
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const { newPassword } = this.state;

    const rules = {
      length: newPassword.length >= 8 && newPassword.length <= 20,
      lowercase: /[a-z]/.test(newPassword),
      uppercase: /[A-Z]/.test(newPassword),
      number: /[0-9]/.test(newPassword),
      specialChar: /[@#$%^&+=]/.test(newPassword),
      noSpace: !/\s/.test(newPassword),
    };

    // const validPassword = new RegExp(
    //   "^(?=.*[0-9])" +
    //     "(?=.*[a-z])(?=.*[A-Z])" +
    //     "(?=.*[@#$%^&+=])" +
    //     "(?=\\S+$).{8,20}$"
    // );
    // const isValidPassword = validPassword.test(this.state.confirmPassword);

    const isValidPassword = Object.values(rules).every(Boolean);

    if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({
        inValidUserErrorMessage: notification.inValidPasswordErrorMessage,
        isLoading: false,
      });
    } else if (!isValidPassword) {
      this.setState({
        inValidUserErrorMessage: notification.invalidPasswordQuality,
        isLoading: false,
      });
    } else if (isValidPassword) {
      this.setState({
        inValidUserErrorMessage: "",
      });
      this.props.acts.forgotPasswordPermission(
        this.state.email,
        this.state.confirmPassword,
        this.state.token
      );
    }
    // localStorage.setItem(messages.USER_EMAIL_IS, this.state.email);
    localStorage.removeItem("invalidPassword");
  };
  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleClickShowConfPassword = () => {
    this.setState({ showConfPassword: !this.state.showConfPassword });
  };
  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleCloseLinkStatusSnackbar = () => {
    // setTimeout(() => {
    // this.props.navigate("/", { replace: true });
    // }, 1000);
    this.props?.acts?.clearCheckLinkStatus();
    this.setState({
      isLinkExpired: false,
    });
  };

  render() {
    const { passwordRules } = this.state;

    const requirements = [
      { key: "length", text: "8-20 characters" },
      { key: "lowercase", text: "At least one lowercase letter" },
      { key: "uppercase", text: "At least one uppercase letter" },
      { key: "number", text: "At least one number" },
      { key: "specialChar", text: "At least one special character (@#$%^&+=)" },
      { key: "noSpace", text: "No spaces allowed" },
    ];

    return (
      <Box component="main" className="logInImg">
        <Grid container className="forgotpass-wrap">
          <Grid className="forgotpass-form-wrap" item xs={8} md={4}>
            <div className="loginFormWrap">
              <img src={aventiorLogo} alt="Aventior Logo" />
            </div>
            <h5>Reset Password</h5>
            <form onSubmit={this.handleSubmit} className="forgot-pass-form">
              <FormControl fullWidth={true}>
                {/* <div>
                  <OutlinedInput
                    placeholder="User Name"
                    className="input-wrap"
                    fullWidth={true}
                    required
                    onChange={this.handleEmailChange}
                    name="email"
                  />
                </div> */}

                <div>
                  <OutlinedInput
                    className="input-wrap"
                    fullWidth={true}
                    placeholder="NewPassword"
                    type={this.state.showPassword ? "text" : "password"}
                    required
                    onChange={this.handleNewPasswordChange}
                    name="Newpassword"
                    value={this.state.newPassword}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={this.handleClickShowPassword}
                          onMouseDown={this.handleMouseDownPassword}
                        >
                          {this.state.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    onCopy={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                  />
                </div>

                <div>
                  <OutlinedInput
                    className="input-wrap"
                    fullWidth={true}
                    placeholder="ConfirmPassword"
                    type={this.state.showConfPassword ? "text" : "password"}
                    required
                    onChange={this.handleConfirmPasswordChange}
                    name="confirmPassword"
                    value={this.state.confirmPassword}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={this.handleClickShowConfPassword}
                          onMouseDown={this.handleMouseDownPassword}
                        >
                          {this.state.showConfPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    onCopy={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                  />
                </div>

                <Box
                  sx={{
                    maxWidth: 400,
                  }}
                >
                  <Label text="Password must contain:" textTransform="none" />
                  <List sx={{ p: "0px 0px 10px 0px" }} dense={true}>
                    {requirements?.map((req) => (
                      <ListItem
                        key={req.key}
                        sx={{ padding: "0px 5px 0px 5px", minHeight: "25px" }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: "24px",
                            mr: 0.5,
                            ml: 0,
                            p: 0,
                            "& svg": {
                              height: "18px !important",
                            },
                          }}
                        >
                          {passwordRules[req.key] ? (
                            <CheckCircle
                              color="success"
                              fontSize="small"
                              size="small"
                            />
                          ) : (
                            <Cancel
                              color="error"
                              fontSize="small"
                              size="small"
                            />
                          )}
                        </ListItemIcon>

                        <ListItemText
                          primaryTypographyProps={{
                            color: passwordRules[req.key]
                              ? "success.main"
                              : "text.primary",
                            fontWeight: "small",
                            variant: "body2",
                          }}
                          primary={req.text}
                          sx={{
                            m: 0,
                            typography: "body3",
                            lineHeight: 1,
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Box>

                {this.state.inValidUserErrorMessage && (
                  <div className="error_messge">
                    <ErrorOutlineIcon color="error" />
                    <div className="error">
                      <label>{this.state.inValidUserErrorMessage}</label>
                    </div>
                  </div>
                )}
                <Button
                  type="submit"
                  variant="contained"
                  className={
                    !(this?.state?.newPassword && this?.state?.confirmPassword)
                      ? "forgot-disabled"
                      : "forgot-continue"
                  }
                  onClick={this.handleSubmit}
                  disabled={
                    !(this?.state?.newPassword && this?.state?.confirmPassword)
                  }
                >
                  Continue
                </Button>
                <div className="version-wrap">
                  <p className="app-version-text">Application Version</p>
                  <p className="app-version-number">2.0</p>
                </div>
              </FormControl>
            </form>
          </Grid>
        </Grid>
        {this?.props?.forgotPasswordStatus?.next === true &&
          this?.props?.forgotPasswordStatus.message !== "" && (
            <CustomizedSnackbars
              severity="success"
              state={this?.state?.sucessNotification}
              text={this?.props?.forgotPasswordStatus.message}
              handleClose={() => this.props?.acts?.clearForgoPasswordStatus()}
            />
          )}
        {this?.props?.forgotPasswordStatus?.next === false &&
          this?.props?.forgotPasswordStatus.loader === false &&
          this?.props?.forgotPasswordStatus.message !== "" && (
            <CustomizedSnackbars
              severity="error"
              state={this?.props?.forgotPasswordStatus.message}
              text={this?.props?.forgotPasswordStatus.message}
              handleClose={() => this.props?.acts?.clearForgoPasswordStatus()}
            />
          )}

        {this.state.isLinkExpired && (
          <CustomizedSnackbars
            severity="error"
            state={this?.state?.isLinkExpired}
            text={this?.props?.changePasswordLinkStatus?.message}
            handleClose={() => this.handleCloseLinkStatusSnackbar()}
          />
        )}
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    forgotPasswordStatus: state.auth.forgotPasswordStatus,
    changePasswordLinkStatus: state.auth.changePasswordLinkStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
